import * as React from 'react';

import {
  Avatar,
  Button,
  IconButton,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Chip,
  Dialog,
  Typography,
} from '@mui/material';

import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';

import { useAppData } from '../core/context/AppDataContext';

function UserMenu() {
  const { appUserInfo } = useAppData();

  const [userDialogOpen, setUserDialogOpen] = React.useState<boolean>(false);

  const handleUserInfoClick = () => setUserDialogOpen(true);
  const handleUserDialogClose = () => setUserDialogOpen(false);

  return (
    <React.Fragment>
      <IconButton color="inherit" onClick={handleUserInfoClick}>
        <PersonIcon />
      </IconButton>
      <Dialog open={userDialogOpen} onClose={handleUserDialogClose}>
        <Card>
          <CardHeader
            avatar={(
              <Avatar>
                {appUserInfo?.name?.split(' ').map((w) => w[0]).join('') ?? '--'}
              </Avatar>
            )}
            title={appUserInfo?.name}
            subheader={appUserInfo?.employeeId}
          />
          <CardContent>
            <Typography variant="h6">Roles</Typography>
            {appUserInfo?.roles?.map((role) => (
              <Chip
                key={role}
                label={role}
                color="primary"
                variant="outlined"
                sx={{ mr: 1, mb: 1 }}
              />
            ))}
          </CardContent>
          <CardActions>
            <Button
              color="secondary"
              endIcon={<LogoutIcon />}
              href="/Account/Logout"
            >
              Logout
            </Button>
            <Button
              autoFocus
              color="primary"
              onClick={handleUserDialogClose}
            >
              Close
            </Button>
          </CardActions>
        </Card>
      </Dialog>
    </React.Fragment>
  );
}

export default UserMenu;
